import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Menu, MenuItem, IconButton, CssBaseline, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { Box } from '@mui/system';
import logo from '../../assets/senai.svg';

import Usuarios from '../Usuarios';
import Inscricoes from '../Inscricoes';
import Cursos from '../Cursos';
import Turmas from '../Turmas';

const Admin = ({ children }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const [tela, setTela] = useState('');

  const menuItems = [
    { text: 'Home', path: '/', action: '', divider: true },
    { text: 'Cadastro de Cursos', path: '', action: 'Cursos', divider: false },
    { text: 'Cadastro de Usuários', path: '', action: 'Usuários', divider: false },
    { text: 'Cadastro de Turmas', path: '', action: 'Turmas', divider: true },
    { text: 'Ver Inscrições', path: '', action: 'Inscrições', divider: false }

  ];

  useEffect(() => {
    // Função que será chamada quando o usuário usar os botões de "voltar" ou "avançar"
    const handlePopState = () => {
      // Remove o token de autenticação
      localStorage.removeItem('authId');
      // Redireciona para a página de login ou home
      navigate('/');
    };

    // Adiciona o listener de evento 'popstate' que é acionado nos botões de navegação do navegador
    window.addEventListener('popstate', handlePopState);

    // Remove o listener quando o componente é desmontado
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);


  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (path, action) => {
    setAnchorEl(null);
    if (path) {
      localStorage.removeItem('authId');
      navigate(path);
    } else if (action) {
      setTela(action);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '80vh' }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: 'white', color: 'red' }}>
        <Toolbar>
          <img src={logo} alt="Logotipo" style={{ height: 40, marginRight: 16 }} />
          <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
            {tela}
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleMenuClick}
          >
            <MenuIcon />
            <Typography variant="h6" noWrap sx={{ marginLeft: 1 }}>
              Menu
            </Typography>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => handleMenuClose()}
          >
            {menuItems.map((item, index) => (
              [
                <MenuItem key={`menu-item-${index}`} onClick={() => handleMenuClose(item.path, item.action)}>
                  {item.text}
                </MenuItem>,
                item.divider && <Divider key={`divider-${index}`} />
              ]
            ))}
          </Menu>
        </Toolbar>
      </AppBar>
      {tela === 'Usuários' && (
        <Usuarios />
      )}
      {
        tela === 'Inscrições' && (
          <Inscricoes />
        )
      }
      {
        tela === 'Cursos' && (
          <Cursos />
        )
      }
      {
        tela === 'Turmas' && (
          <Turmas />
        )
      }
    </Box>

  );
};

export default Admin;
